import { __decorate } from "tslib";
import { ValidatorConstraint } from 'class-validator';
import { SUPPORTED_COUNTRIES } from '../Country';
/**
 * Validates whether a Country Code is a country code of a supported country.
 * @see https://github.com/typestack/class-validator#custom-validation-classes
 */
let SupportedCountry = class SupportedCountry {
    validate(countryCode) {
        return !!SUPPORTED_COUNTRIES.find(cntry => cntry.code === countryCode);
    }
    defaultMessage() {
        return '$value is not a supported country code.';
    }
};
SupportedCountry = __decorate([
    ValidatorConstraint({ name: 'supportedCountry', async: false })
], SupportedCountry);
export { SupportedCountry };
